import apiClient from "./api"; // On utilise le client API configuré

// Générer un rapport pour l'historique d'un compte (pour une seule action corporate)
export const generateAccountHistoricReport = async (idCorporateAction, domainId) => {
  try {
    const response = await apiClient.post(`api/AccountHistoric/generate-report/${idCorporateAction}/${domainId}`);
    return response.data; // ex: { url: '...', blobName: '...', fileName: '...' }
  } catch (error) {
    throw error.response?.data || { message: "Une erreur de communication est survenue." };
  }
};


